import { Button, useMediaQuery } from '@mui/material';
import { withRouter } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTheme } from '@emotion/react';
import { ButtonBackMobile } from './ButtonBackMobile';

const ButtonBack = (props) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      {isMobileScreen ? (
        <ButtonBackMobile {...props} />
      ) : (
        <Button
          variant={props.variant || 'text'}
          color='secondary'
          size={props.size || 'small'}
          startIcon={<ArrowBackIcon />}
          onClick={props.onClick || props.history.goBack}
          sx={{ mb: Number(props.marginBotton) || 1, fontWeight: 'bold' }}
          aria-label='Volver a la página anterior'
        >
          Atrás
        </Button>
      )}
    </>
  );
};

export default withRouter(ButtonBack);
